import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type BadgeVariant = 'default' | 'accent' | 'coral' | 'gold' | 'muted';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClass: Record<BadgeVariant, string> = {
  default: '',
  accent: 'badge-accent',
  coral: 'badge-coral',
  gold: 'badge-gold',
  muted: 'badge-muted',
};

export function Badge({
  variant = 'default',
  className,
  ...rest
}: BadgeProps): JSX.Element {
  return <span className={cn('badge', variantClass[variant], className)} {...rest} />;
}
